import { useMediaQuery } from 'usehooks-ts'
import { useSearch } from '@/src/contexts'

import { Menu } from 'antd'

import type { MenuProps } from 'antd'

type SearchBarCategoriesProps = {
  setAutocompleteQuery: (value: { key: string; value: string }) => void
  setPhysicianError: (error: string | null) => void
}
type MenuItem = Required<MenuProps>['items'][number]

export const SearchBarCategories = ({
  setAutocompleteQuery,
  setPhysicianError,
}: SearchBarCategoriesProps) => {
  const {
    currentSearchBarCategory,
    setCurrentSearchBarCategory,
    setQuery,
    query,
  } = useSearch()

  const isMobile = useMediaQuery('(max-width: 640px)')

  const searchItems: MenuItem[] = [
    {
      key: 'unified',
      label: 'Condition or Physician Specialty',
    },
    {
      key: 'full_name',
      label: 'Physician Name',
    },
  ]

  const onClick: MenuProps['onClick'] = (e) => {
    const newCategory = e.key
    setCurrentSearchBarCategory(newCategory)

    // Only update query and autocomplete if there's a value to clear
    if (query.singleValueParameters?.value) {
      // Update the query with empty singleValue parameter for the new category
      setQuery((prevQuery) => ({
        ...prevQuery,
        singleValueParameters: {
          key: newCategory,
          value: '',
        },
      }))
    }
    // Clear the autocomplete query
    setAutocompleteQuery({ key: newCategory, value: '' })
    setPhysicianError(null)
  }

  return (
    <Menu
      mode={isMobile ? 'vertical' : 'horizontal'}
      items={searchItems}
      onClick={onClick}
      style={{
        margin: '0 0 20px 0',
        background: 'transparent',
        borderBottom: '1px solid #D9D9D9FF',
      }}
      selectedKeys={[currentSearchBarCategory]}
    />
  )
}
